import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { Lock, Eye, ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const Privacy = () => {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen flex flex-col bg-background">
            <Navbar />
            <main className="flex-1 pt-24 pb-16">
                <div className="container mx-auto px-4 max-w-4xl">
                    <div className="text-center mb-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
                        <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-2xl mb-4 text-primary">
                            <Lock className="h-8 w-8" />
                        </div>
                        <h1 className="text-4xl font-bold mb-4">{t("นโยบายความเป็นส่วนตัว", "Privacy Policy")}</h1>
                        <p className="text-muted-foreground">{t("ปรับปรุงล่าสุดเมื่อ 1 มกราคม 2567", "Last updated: January 1, 2024")}</p>
                    </div>

                    <Card variant="glass" className="border-primary/10 shadow-xl animate-in fade-in duration-700 delay-200">
                        <CardContent className="p-8 md:p-12 prose prose-slate dark:prose-invert max-w-none">
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
                                    <ShieldCheck className="h-6 w-6 text-primary" />
                                    1. {t("ข้อมูลที่เรารวบรวม", "Information We Collect")}
                                </h2>
                                <p>
                                    {t(
                                        "เรารวบรวมข้อมูลส่วนบุคคลที่คุณให้ไว้โดยสมัครใจเมื่อลงทะเบียน เช่น ชื่อ อีเมล และข้อมูลการชำระเงินเมื่อคุณทำรายการสั่งซื้อ",
                                        "We collect personal information that you voluntarily provide when registering, such as your name, email, and payment information when you make a purchase."
                                    )}
                                </p>
                            </section>

                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
                                    <Eye className="h-6 w-6 text-primary" />
                                    2. {t("เราใช้ข้อมูลของคุณอย่างไร", "How We Use Your Information")}
                                </h2>
                                <p>
                                    {t(
                                        "เราใช้ข้อมูลของคุณเพื่อให้บริการ จัดการบัญชีของคุณ และสื่อสารกับคุณเกี่ยวกับการอัปเดตบริการ รวมถึงรายการส่งเสริมการขายที่คุณอาจสนใจ",
                                        "We use your information to provide the service, manage your account, and communicate with you about service updates, including promotional offers you may be interested in."
                                    )}
                                </p>
                            </section>

                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4">3. {t("การคุ้มครองข้อมูล", "Data Protection")}</h2>
                                <p>
                                    {t(
                                        "เราใช้มาตรฐานการรักษาความปลอดภัยที่เหมาะสมเพื่อปกป้องข้อมูลส่วนบุคคลของคุณจากการเข้าถึง การเปิดเผย หรือการเปลี่ยนแปลงโดยไม่ได้รับอนุญาต",
                                        "We use appropriate security standards to protect your personal information from unauthorized access, disclosure, or alteration."
                                    )}
                                </p>
                            </section>

                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4">4. {t("คุกกี้ (Cookies)", "Cookies")}</h2>
                                <p>
                                    {t(
                                        "เราอาจใช้คุกกี้เพื่อปรับปรุงประสบการณ์การใช้งานของคุณและรวบรวมข้อมูลเชิงสถิติเกี่ยวกับการใช้งานเว็บไซต์ของเรา",
                                        "We may use cookies to improve your user experience and collect statistical data about the use of our website."
                                    )}
                                </p>
                            </section>

                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4">5. {t("การเปลี่ยนแปลงนโยบาย", "Policy Changes")}</h2>
                                <p>
                                    {t(
                                        "เราอาจปรับปรุงนโยบายความเป็นส่วนตัวนี้เป็นระยะๆ โดยจะระบุวันที่ปรับปรุงล่าสุดไว้ในส่วนบนของหน้านี้",
                                        "We may update this privacy policy from time to time naming the last update date at the top of this page."
                                    )}
                                </p>
                            </section>

                            <div className="mt-12 pt-8 border-t border-border/50 text-sm text-muted-foreground italic text-center">
                                {t(
                                    "ความสมบูรณ์และความลับของคุณคือสิ่งสำคัญที่สุดสำหรับเรา",
                                    "Your integrity and confidentiality are our highest priorities."
                                )}
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Privacy;
